import React, {Component} from 'react';
import YouTube from 'react-youtube';
import getVideoId from 'get-video-id';
import { injectIntl } from 'react-intl';
import {messages} from  './common/Translations';

class YoutubeUploaderRedux extends React.Component {

    constructor(props) {
        super(props);
        this.state = {youtubeLink: ''};
        this.deleteVideo = this.deleteVideo.bind(this);
    }

    renderYoutube() {
        if (this.props.youtubeId.input.value) {
            return (
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Eksempel</label>
                    <div className="col-sm-5">
                        <div className="embed-responsive embed-responsive-16by9">
                            <YouTube videoId={this.props.youtubeId.input.value}/>
                        </div>
                    </div>
                </div>
            )
        }
    }

    deleteVideo(event) {
        event.preventDefault();
        this.setState({hide: true});
        this.setState({youtubeLink: ''});
        this.props.youtubeId.input.onChange('');
    }

    renderButton() {
        if(this.props.youtubeId.input.value) {
            return (
                <div>
                    <div className="form-group row m-t-20">
                        <div className="col-sm-5 offset-2">
                            <button className="btn btn-outline-danger" onClick={this.deleteVideo}>Fjern video</button>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderYoutubeLinkInput() {
        let {
            text = this.props.intl.formatMessage(messages.enterYoutubeLink)
        } = this.props;

        return (
            <div className="form-group row">
                <label className="col-sm-2 col-form-label"><b>Video</b></label>
                <div className="col-sm-10">
                    <input className="form-control"
                           type="text"
                           name="youtube-link"
                           placeholder="http://"
                           value={this.state.youtubeLink}
                           onChange={event => this.parseId(event)}/>
                    <small className="form-text text-muted">{text}</small>
                </div>
            </div>
        );
    }

    parseId(event) {
        let result = getVideoId(event.target.value);
        this.setState({youtubeLink: event.target.value});
        if (result !== undefined) {
            this.props.youtubeId.input.onChange(result.id);
        }
    }

    render() {
        return (
            <div>
                {this.renderYoutubeLinkInput()}
                {this.renderYoutube()}
                {this.renderButton()}
            </div>
        );
    }
}

export default injectIntl(YoutubeUploaderRedux);


// WEBPACK FOOTER //
// ./web/src/components/YoutubeUploaderRedux.jsx